import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilterField, FilterOperator, Ticket, TicketRequirement, User } from 'src/app/models';
import { TcTicketRequirementService } from 'src/app/shared/services';
import { utils } from 'src/app/shared';
import { PatronColors, ToastService } from '@teorema/patron';

@Component({
  selector: 'requirements-tab',
  templateUrl: './requirements-tab.component.html',
  styles: [],
  standalone: false,
})
export class RequirementsTabComponent {
  @Input() unconfirmedTicket?: Ticket;
  @Input() user?: User;

  ticketReq?: TicketRequirement;
  loading: boolean = false;
  ticketRequirements?: TicketRequirement[];
  // deleteConfirmationModal: BsModalRef;
  deleteIndex = -1;
  formRequirementTicket!: FormGroup;
  visibleModalDelete: boolean = false;
  deleteMessageModal?: string;

  constructor(
    private toastr: ToastService,
    private formBuilder: FormBuilder,
    private ticketRequirementService: TcTicketRequirementService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {
    this.clearTicketReq();
    this.formRequirementTicket = this.formBuilder.group({
      requirement: [null, Validators.required],
    });
  }

  async addTicketReq() {
    if (!this.ticketRequirements) {
      this.ticketRequirements = [];
    }
    if (!this.formRequirementTicket.get('requirement')?.value) {
      this.toastr.show({ color: 'error', message: 'Campo vazio por favor adicione um requisito' });
      return;
    }

    this.ticketReq!.requirement = this.formRequirementTicket.get('requirement')?.value;
    if (
      this.ticketRequirements.find(
        tr => tr.requirement && tr.requirement.id === this.ticketReq!.requirement!.id
      )
    ) {
      this.toastr.show({ color: 'error', message: 'Esse requisito já foi adicionado ao chamado' });
      return;
    }

    this.ticketReq!.user = this.user;
    this.ticketReq!.ticket = {
      id: this.unconfirmedTicket!.id,
    } as Ticket;

    this.loading = true;

    let response = await this.ticketRequirementService
      .save(this.ticketReq!)
      .catch(() => {
        this.toastr.show({
          color: 'error',
          message: 'Houve um erro ao salvar',
        });
      })
      .finally(() => {
        this.loading = false;
      });

    if (response?.id) {
      this.toastr.show({
        color: 'success',
        message: 'Requisito adicionado com sucesso!',
      });
      this.setComplexityLabel(response!);
      this.ticketRequirements.unshift(response!);
      this.clearTicketReq();
      this.cdr.markForCheck();
    }
  }

  openDeleteConfirmationModal(index) {
    this.deleteIndex = index;
    this.deleteMessageModal = `Tem certeza de que deseja remover o requisito "${this.ticketRequirements![this.deleteIndex].requirement!.description}" do chamado?`;

    this.visibleModalDelete = true;
  }

  async delete() {
    this.loading = true;
    let response = await this.ticketRequirementService
      .delete(this.ticketRequirements![this.deleteIndex].id)
      .catch(() => {
        this.toastr.show({
          color: 'error',
          message: 'Houve um erro ao deletar',
        });
      })
      .finally(() => {
        this.loading = false;
      });

    if (response === true) {
      this.toastr.show({
        color: 'success',
        message: 'ID Commit removido com sucesso',
      });
      this.loading = false;
      this.ticketRequirements!.splice(this.deleteIndex, 1);
      this.deleteIndex = -1;
      this.visibleModalDelete = false;
      this.cdr.markForCheck();
    }
  }

  cancelModal() {
    this.visibleModalDelete = false;
  }

  clearTicketReq() {
    this.ticketReq = new TicketRequirement();
    this.formRequirementTicket?.get('requirement')?.setValue(null);
  }

  setComplexityLabel(tr: TicketRequirement) {
    if (tr.requirement && tr.requirement.complexity) {
      tr.requirement.complexity_label = this.getComplexityLabel(tr.requirement.complexity);
      tr.requirement.complexity_color = this.getComplexityColor(tr.requirement.complexity);
    }
  }

  getComplexityLabel(complexity: number): string {
    switch (complexity) {
      case 1:
        return 'Baixa 1 hora';
      case 2:
        return 'Baixa 2 horas';
      case 3:
        return 'Média 3 horas';
      case 4:
        return 'Média 4 horas';
      case 5:
        return 'Alta 5 horas';
      case 10:
        return 'Complexa 10 horas';
      default:
        return complexity.toString();
    }
  }

  getComplexityColor(complexity: number): string {
    switch (complexity) {
      case 1:
      case 2:
        return 'success';
      case 3:
      case 4:
      case 5:
        return 'warning';
      case 10:
        return 'danger';
      default:
        return 'secondary';
    }
  }

  convertComplexityColor(complexity: string | undefined): PatronColors | undefined {
    return complexity as PatronColors;
  }

  async loadTicketRequirements() {
    this.ticketRequirements = [];
    this.loading = true;
    let promisse: any = null;
    promisse = this.ticketRequirementService.findAll({
      filters: [
        new FilterField({
          name: 'equal[ticket_id]',
          value: this.unconfirmedTicket?.id,
          operator: FilterOperator.has,
          label: '',
        }),
      ],
    });

    let response = await promisse.catch(e => {
      console.error(e);
      this.loading = false;
      this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });
    if (response?.data?.length) {
      this.loading = false;
      this.ticketRequirements = response.data;
      this.setComplexityLabels();
      this.cdr.markForCheck();
    }
  }

  setComplexityLabels() {
    if (this.ticketRequirements) {
      this.ticketRequirements.forEach(tr => {
        this.setComplexityLabel(tr);
      });
    }
  }

  isDevCanWrite() {
    return utils.checkAccess(['Development'], true, true).result;
  }
}
